import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

import TestsRequests from "services/tests";

import ScoreManagementTableHeading from "./ScoreManagementTableHeading";
import ScoreManagementTableItem from "./ScoreManagementTableItem";

const ScoreManagementListTable = ({ searchMode, searchInput }) => {
  const dispatch = useDispatch();
  const { scores, scoresCurrentPage, scoresTotalPage } = useSelector(
    ({ tests }) => tests
  );

  useEffect(() => {
    if (searchMode) {
      dispatch(TestsRequests.getScores(1, searchInput));
    } else {
      dispatch(TestsRequests.getScores(1));
    }
  }, [searchInput, searchMode]);

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(TestsRequests.getScores(value, searchInput));
    } else {
      dispatch(TestsRequests.getScores(value));
    }
  };

  return (
    <div className="Cmt-table-responsive">
      {scores &&
        (scores.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <ScoreManagementTableHeading />
            </TableHead>
            <TableBody>
              {scores.map((item) => (
                <ScoreManagementTableItem
                  data={item}
                  key={item._id}
                  id={item._id}
                />
              ))}
            </TableBody>
          </Table>
        ))}
      {scores.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={scoresTotalPage}
            color="primary"
            page={scoresCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default ScoreManagementListTable;
